import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { default as fragments } from '../../fragments'

import {
  Spinner,
  TextArea,
  Input,
  InfoDisplay
} from '../../components'

class DivisionInformation extends React.Component {
  static propTypes = {
    data: PropTypes.object.isRequired
  }

  state = {
    edit: false,
    name: "Loading",
    notes: "Loading"
  }

  goReadOnly = () => {
    this.setState({ edit : false });
  }

  goEdit = () => {
    let division = this.props.data.division
    this.setState({
      edit: true,
      name: division.name,
      notes: division.notes
    });
  }

  canUpdate = () => {
    return this.props.data.division.name !== this.state.name ||
      this.props.data.division.notes !== this.state.notes
  }

  handleUpdate = () => {
    if (this.canUpdate()) {
      let division = this.props.data.division
      let divisionInfo = {
        id: this.props.data.division.id
      }

      if (division.name !== this.state.name)
        divisionInfo.name = this.state.name

      if (division.notes !== this.state.notes)
        divisionInfo.notes = this.state.notes

      this.props.updateDivision({variables: { input: divisionInfo }})
        .then(this.goReadOnly)
    }
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner className='slds-is-relative' size='small' />
    }

    const divisionRecord = this.props.data.division

    let divisionInfoRows = (<tbody>
      <tr>
        <th className='slds-size_1-of-4 slds-theme--shade slds-text-heading--label slds-cell-wrap'>Name</th>
          <td>{this.state.edit
              ? <Input
                  id="name"
                  placeholder='Name'
                  value={this.state.name}
                  onChange={(e) => this.setState({friendlyName: e.target.value})}
                 />
              : divisionRecord.name
            }
          </td>
      </tr>
      <tr>
        <th className='slds-size_1-of-4 slds-theme--shade slds-text-heading--label slds-cell-wrap'>Notes</th>
          <td className='slds-cell-wrap'>{this.state.edit
              ? <TextArea
                  id="notes"
                  placeholder='Notes'
                  value={this.state.notes}
                  onChange={(e) => this.setState({notes: e.target.value})}
                 />
              : divisionRecord.notes
            }
          </td>
      </tr>
    </tbody>)

    return (
      <InfoDisplay
        title="Division Information"
        rows={divisionInfoRows}
        edit={this.state.edit}
        onCancelClick={this.goReadOnly}
        onSaveClick={this.handleUpdate}
        onEditClick={this.goEdit}
        titleBold={false}
        className='slds-m-bottom_x-large'
      />
    )
  }
}

const getDivisionInformation = gql`query($id: ID!) {
    division(id: $id) {
      ...DivisionInformation
    }
  }
  ${fragments.divisionInformation}
`

const updateDivision = gql`
  mutation updateDivision($input: DivisionMutationInput!) {
    divisionMutate(input: $input) {
      division {
        ...DivisionInformation
      }
    }
  }
  ${fragments.divisionInformation}
`

const withData =
  graphql(getDivisionInformation, {
    options: (ownProps) => ({
      variables: {
        id: ownProps.divisionId
      }
    })
  })

const withUpdate =
  graphql(updateDivision, { name: "updateDivision"})

export default withData(withUpdate(DivisionInformation))



// WEBPACK FOOTER //
// ./src/components/division-information/index.js